import { IAppState } from "../state/app.state";
import { createSelector } from "@ngrx/store";
import { IEdpeState } from "@edp-store/state/edpe.state";
import { IUserState } from "@edp-store/state/user.state";
import { ParishCampaignUserPoints } from "@edp-models/edp-campaigns.model";

const dashboardCardsSelector = (state: IAppState) => state.edpe;
const userSelector = (state: IAppState) => state.user;

export const getDashboardCards = createSelector(
    dashboardCardsSelector,
    (state: IEdpeState) => state.dashboardCards
);

export const getDashboardGeneratedCodeCards = createSelector(
    dashboardCardsSelector,
    (state: IEdpeState) => state.dashboardGeneratedCodeCards
);

export const getShowAlert = createSelector(
    dashboardCardsSelector,
    userSelector,
    (state: IEdpeState, user: IUserState) => {
        return user.user.partnerNumber && !localStorage.getItem("user-tob-bar") && !user.user.edpESubscribed;
    }
);

export const getUserEfficiency = createSelector(
    dashboardCardsSelector,
    (state: IEdpeState) => state.userEfficiency
);

export const getDashboardSections = createSelector(
    dashboardCardsSelector,
    (state: IEdpeState) => state.dashboardSections
);

export const loadedDashboard = createSelector(
    (state: IAppState) => state.edpe.loadedDashboard,
    (loadedDashboard: boolean) => loadedDashboard
);

export const getUserAvailableParishList = createSelector(
    dashboardCardsSelector,
    (state: IEdpeState) => state.userAvailableParishList
);

export const getUserParticipation = createSelector(
    dashboardCardsSelector,
    (state: IEdpeState) => state.userParticipation
);

export const getUserPoints = createSelector(
    dashboardCardsSelector,
    (state: IEdpeState) => {
        return {
            zsPoints: state.userParticipation.userParticipation.zs_points,
            points: state.userParticipation.userParticipation.points,
            parishScore: state.userParticipation.parishScore.points
        } as ParishCampaignUserPoints;
    }
);

export const getMgmCode = createSelector(
    dashboardCardsSelector,
    (state: IEdpeState) => state.mgmCode
);

export const getQuizzs = createSelector(dashboardCardsSelector, (state: IEdpeState) => state.quizzs);
